import { ListCard } from "components";
import type { ListCardProps } from "components/ListCard";
import type { ReactStoryblokComponent } from "types/storyblok";

const ListCardAdapter = ({
  blok: { listItems, title, mtMobile, mtTablet, mtDesktop, mbMobile, mbTablet, mbDesktop },
}: ReactStoryblokComponent<ListCardProps>) => (
  <ListCard
    listItems={listItems}
    title={title}
    mtMobile={mtMobile}
    mtTablet={mtTablet}
    mtDesktop={mtDesktop}
    mbMobile={mbMobile}
    mbTablet={mbTablet}
    mbDesktop={mbDesktop}
  />
);

export default ListCardAdapter;
